import { motion } from "framer-motion";
import { Target, Users, CalendarRange, GraduationCap } from "lucide-react";

const chapters = [
  {
    n: "01",
    icon: Target,
    title: "Obiettivo",
    text: "Fornire conoscenze teoriche e competenze pratiche per valutare, classificare e trattare in modo efficace e sicuro le deformità craniche posizionali del neonato e del lattante, con un approccio basato sulle più recenti evidenze scientifiche.",
  },
  {
    n: "02",
    icon: Users,
    title: "Destinatari",
    text: "Osteopati, fisioterapisti pediatrici, tecnici ortopedici, medici e professionisti sanitari che lavorano con neonati e lattanti nei primi due anni di vita.",
  },
  {
    n: "03",
    icon: CalendarRange,
    title: "Programma",
    text: "Sabato 14 e Domenica 15 Novembre 2026, 12 ore totali presso il Centro Osteopatico Ninni a Taranto: inquadramento e classificazione delle deformità craniche, valutazione clinica e strumentale, scansione volumetrica digitale vs craniometro analogico, strategie di trattamento integrate e casi clinici pratici. Al termine verrà rilasciato l'attestato di partecipazione. Posti limitati: 10 partecipanti.",
  },
  {
    n: "04",
    icon: GraduationCap,
    title: "Docente",
    text: "Dott. Armando Mattia Ninni D.O. — Tecnico Ortopedico, Osteopata Pediatrico e Chinesiologo, specializzato nella valutazione del neonato nei primi due anni di vita e referente europeo della tecnologia BS3D di scansione volumetrica cranica digitale.",
  },
];

export const Chapters = () => (
  <section className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16" data-testid="chapters-section">
    <div className="max-w-7xl mx-auto">
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        className="text-xs uppercase tracking-[0.25em] font-mono font-semibold text-coral mb-4"
      >
        Il percorso
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="font-serif text-2xl sm:text-3xl lg:text-4xl font-medium text-ink tracking-tight max-w-2xl mb-16"
      >
        Quattro capitoli, un unico metodo di lavoro.
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12">
        {chapters.map((c, i) => (
          <motion.article
            key={c.n}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className={`relative bg-white border border-petrol/10 rounded-2xl p-7 sm:p-10 hover:border-petrol/30 transition-all duration-300 hover:shadow-xl hover:shadow-petrol/5 ${i % 2 === 1 ? "md:mt-16" : ""}`}
            data-testid={`chapter-${c.n}`}
          >
            <span className="absolute -top-7 right-6 font-serif font-extralight text-6xl sm:text-7xl text-coral/25 select-none">
              {c.n}
            </span>
            <c.icon className="w-8 h-8 text-coral mb-5" strokeWidth={1.5} />
            <h3 className="font-serif text-xl sm:text-2xl font-medium text-petrol mb-4">{c.title}</h3>
            <p className="text-sm sm:text-base text-slate2 leading-relaxed">{c.text}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
